
import { defineComponent, reactive } from 'vue'
import { HistoryListRequest } from '@/requests/message'
import { MessageHistoryForDetail } from '@/api'
import { AxiosResponse } from 'axios'

import DateDisplay from '@/components/displays/DateDisplay.vue'
import MessageSenderOrRecipientName from '@/components/displays/MessageSenderOrRecipientName.vue'
import MessageHistoryBody from '@/components/displays/MessageHistoryBody.vue'

import { displaySenderOrRecipientName } from '@/services/messageAddress'

/**
 * メッセージ履歴の表示コンポーネント
 * 受信欄はel-tooltip内でv-forを回せないため、繋げてから表示している
 */
export default defineComponent({
  name: 'MessageHistory',
  components: {
    DateDisplay,
    MessageSenderOrRecipientName,
    MessageHistoryBody,
  },
  props: {
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: true,
    },
    // メッセージタイプ
    messageType: {
      type: Number,
      required: false,
      default: null,
    },
    // メッセージ種別グループ
    messageGroup: {
      type: Number,
      required: false,
      default: null,
    },
  },
  async setup(props) {
    // メッセージ一覧
    const messages = reactive<MessageHistoryForDetail[]>([])

    const request = new HistoryListRequest(props.requestHeaderId, props.messageType, props.messageGroup)
    await request.exec()
    if (request.success) {
      const { data } = request.getResponse() as AxiosResponse<MessageHistoryForDetail[]>
      messages.push(...data)
    }
    return {
      messages,
      displaySenderOrRecipientName,
    }
  },
})
